import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["kind", "section"]

  declare readonly kindTarget: HTMLSelectElement | HTMLInputElement
  declare readonly sectionTargets: HTMLElement[]

  connect(): void {
    this.toggle()
  }

  toggle(): void {
    const kind = this.kindTarget instanceof HTMLInputElement && this.kindTarget.type === "checkbox" && !this.kindTarget.checked ? "" : this.kindTarget.value
    this.sectionTargets.forEach((section) => {
      section.hidden = !(section.dataset.kinds ?? "").split(" ").includes(kind)
    })
  }
}
